module.exports = __webpack_public_path__ + "static/media/caret-default.dc086f14.svg";